var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.21 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b9b9b9;}.cls-2{opacity:0.38;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_201",
    "data-name": "\\uADF8\\uB8F9 201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC758\\uB8CC\\uB370\\uC774\\uD130_\\uC911\\uC2EC\\uBCD1\\uC6D0",
    "data-name": "\\uC758\\uB8CC\\uB370\\uC774\\uD130 \\uC911\\uC2EC\\uBCD1\\uC6D0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.55,14.94c-1.79.07-3.71.14-5.07.12l-.31-1.81c1.87,0,3.42,0,5.25-.09,2-.07,4-.22,5.39-.4L62,14.48C60.46,14.66,58.27,14.84,56.55,14.94ZM56.28,3.5c2.73,0,4.47,1.61,4.47,3.87S59,11.24,56.28,11.24s-4.49-1.61-4.49-3.87S53.56,3.5,56.28,3.5Zm0,6a2.1,2.1,0,1,0,0-4.18A2.09,2.09,0,0,0,54,7.35a2.11,2.11,0,0,0,2.32,2.12Zm8.48,9.12h-2.1V2.47h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.67,12.38v2.51h3.71v1.69H66.81V14.89H70.5V12.38H68.67V7h8.76V5.18H68.59V3.5H79.53V8.73H70.78v1.95H80v1.7ZM72.56,14.9h3.08V12.38H72.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.58,12.74l.25,1.63a26.54,26.54,0,0,1-5.35.42H82.94V4.38H89V6.05h-4v7.07A20.25,20.25,0,0,0,89.58,12.74ZM88.15,10V8.35h2.77V2.75h2v15.1h-2V10Zm6,8.56V2.47h2V18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.74,3.57c2.64,0,4.18,2.37,4.18,5.77s-1.54,5.74-4.18,5.74-4.16-2.35-4.16-5.74S100.11,3.57,102.74,3.57Zm0,1.7c-1.21,0-2.1,1.52-2.1,4.07s.89,4,2.1,4,2.15-1.51,2.15-4S104,5.27,102.74,5.27Zm6.62,13.32V2.47h2.1V18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.74,12.83l.23,1.62a35,35,0,0,1-7,.54h-1.54V3.86h7.41V5.54h-5.33V8.29h4.64V10h-4.64v3.31A26.52,26.52,0,0,0,122.74,12.83ZM125,18.59V10h-2.7V8.22H125V2.47h2.1V18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.6,11.6v1c3,.2,4.72,1.29,4.72,2.9,0,1.79-2.1,2.9-5.75,2.9s-5.74-1.11-5.74-2.9c0-1.61,1.7-2.7,4.65-2.9v-1h-6.19V9.9h14.58v1.7Zm4.61-2.28c-2.35-.2-4.7-1.44-5.64-3-.82,1.59-3.08,2.79-5.63,3-.29-.56-.6-1.1-.89-1.64,2.52-.11,4.71-1.14,5.27-2.76H134.8V3.23h11.62V4.91h-4.55c.65,1.63,3.09,2.64,5.25,2.75Zm-5.66,5c-2.17,0-3.57.46-3.57,1.27s1.4,1.23,3.57,1.23,3.62-.45,3.62-1.23S142.74,14.28,140.55,14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.58,11.1A7.26,7.26,0,0,1,154,7.86a6.32,6.32,0,0,1-3.71,3.71L149,9.88a5.52,5.52,0,0,0,3.87-5.23V3.28h2.21V4.55a5.25,5.25,0,0,0,3.72,4.9Zm-6,7.29V12.47h10.7v5.92Zm8.58-4.29h-6.45v2.64h6.44Zm2.12-11.64v9.23h-2.12V2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.13,11V3.4h2.11V5.67h3.37V3.35h2.1V11Zm7.37,7.6c-3.48,0-5.51-1.28-5.51-3.24s2-3.27,5.51-3.27,5.55,1.26,5.55,3.27S176,18.57,172.5,18.57ZM170.61,7.3h-3.37v2h3.37Zm-1.45,8c0,1,1.25,1.54,3.34,1.54s3.36-.58,3.36-1.54-1.19-1.57-3.36-1.57S169.16,14.35,169.16,15.33Zm8.76-3.44h-2.1V9.68h-2.29V8h2.29V6.3h-2.29V4.65h2.29V2.47h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185,14.15V11.28c-1.69.05-3.26.07-4.47.07-.1-.54-.19-1.12-.29-1.67a93,93,0,0,0,10.28-.48l.12,1.55c-1.1.19-2.3.29-3.54.38v3Zm.45-5.21c-2.35,0-4.09-1.23-4.09-3S183,3,185.4,3s4,1.26,4,3S187.76,8.94,185.4,8.94Zm-3.1,9.21V13.41h2.12v3.06h9.72v1.68Zm3.1-13.61c-1.23,0-2,.72-2,1.43s.73,1.38,2,1.38,1.93-.67,1.93-1.38-.74-1.42-1.93-1.42Zm3.28,7.24h3.07V2.47h2.12V14.94h-2.12V13.31h-3.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.79,39.48a4.7,4.7,0,0,1-2-1.44,3.41,3.41,0,0,1-.72-2,.41.41,0,0,1,.13-.28.4.4,0,0,1,.31-.13H54a.78.78,0,0,1,.37.09,1.63,1.63,0,0,1,.31.27,2,2,0,0,0,.82.85,3.08,3.08,0,0,0,1.52.34,3.43,3.43,0,0,0,1.72-.34,1.1,1.1,0,0,0,.59-1A1,1,0,0,0,59,35.2a2.86,2.86,0,0,0-.95-.49c-.44-.14-1.07-.3-1.93-.49a8.45,8.45,0,0,1-3.53-1.44,3.34,3.34,0,0,1-1.17-2.72,3.75,3.75,0,0,1,.67-2.15A4.42,4.42,0,0,1,54,26.41a7.34,7.34,0,0,1,2.89-.53,7,7,0,0,1,3,.6A4.89,4.89,0,0,1,61.75,28a3.2,3.2,0,0,1,.69,1.75.42.42,0,0,1-.12.3.4.4,0,0,1-.29.12h-2.6a1,1,0,0,1-.38-.08.75.75,0,0,1-.27-.26,1.32,1.32,0,0,0-.64-.77,3,3,0,0,0-2.64,0A1,1,0,0,0,55,30a.94.94,0,0,0,.27.69,2.26,2.26,0,0,0,.86.5,12.83,12.83,0,0,0,1.72.46,12.49,12.49,0,0,1,2.92.84,3.27,3.27,0,0,1,2.11,3.29A3.61,3.61,0,0,1,62.15,38a4.64,4.64,0,0,1-2.1,1.49,9.4,9.4,0,0,1-6.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.56,39.7a.54.54,0,0,1-.13-.35V26.57a.43.43,0,0,1,.15-.34.48.48,0,0,1,.34-.14h2.54a.5.5,0,0,1,.36.14.47.47,0,0,1,.15.34v4.72H76.8V26.57a.48.48,0,0,1,.48-.48h2.54a.48.48,0,0,1,.48.48V39.34a.5.5,0,0,1-.14.35.48.48,0,0,1-.34.14H77.28a.48.48,0,0,1-.34-.14.5.5,0,0,1-.14-.35V34.45H72v4.89a.51.51,0,0,1-.15.35.54.54,0,0,1-.36.14H68.92A.53.53,0,0,1,68.56,39.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.51,28a.48.48,0,0,1-.14-.34V25.88a.48.48,0,0,1,.48-.48h2.36a.47.47,0,0,1,.49.45v1.8a.43.43,0,0,1-.13.34.52.52,0,0,1-.35.14H86.86A.45.45,0,0,1,86.51,28Zm0,11.7a.52.52,0,0,1-.14-.35V30.11a.52.52,0,0,1,.14-.35.43.43,0,0,1,.34-.13h2.32a.46.46,0,0,1,.49.45v9.27a.49.49,0,0,1-.13.35.51.51,0,0,1-.35.15H86.88a.51.51,0,0,1-.35-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.91,39.69a.5.5,0,0,1-.14-.35V26.57a.42.42,0,0,1,.14-.34.52.52,0,0,1,.35-.14h2.09a.67.67,0,0,1,.67.37L103.81,34V26.57a.47.47,0,0,1,.15-.34.5.5,0,0,1,.35-.14h2.35a.5.5,0,0,1,.35.14.48.48,0,0,1,.14.34V39.32a.55.55,0,0,1-.14.37.51.51,0,0,1-.35.15h-2.12a.71.71,0,0,1-.65-.38l-4.78-7.27v7.15a.5.5,0,0,1-.14.35.51.51,0,0,1-.35.15H96.27A.53.53,0,0,1,95.91,39.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.58,39.69a.46.46,0,0,1-.14-.35V26.57a.42.42,0,0,1,.14-.34.52.52,0,0,1,.35-.14h9.18a.52.52,0,0,1,.35.14.43.43,0,0,1,.13.34v1.85a.44.44,0,0,1-.13.34.47.47,0,0,1-.35.15h-6.28v2.65h5.85a.45.45,0,0,1,.34.15.54.54,0,0,1,.14.36v1.72a.48.48,0,0,1-.14.34.45.45,0,0,1-.34.15h-5.85V37h6.43a.48.48,0,0,1,.34.14.45.45,0,0,1,.14.34v1.85a.52.52,0,0,1-.14.35.46.46,0,0,1-.34.14h-9.33A.46.46,0,0,1,113.58,39.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.44,34.65l-1-1.68A8.65,8.65,0,0,0,136.11,30l-4.13.48-.38-1.73,5.45-.4a6.55,6.55,0,0,0,.34-1.12h-5.06V25.53h7.33C139.62,29.87,136.76,33.29,132.44,34.65Zm1.5,5.29V35h2.12v3.26H145v1.67Zm5.63-9V29.2h3v-5h2.11V36h-2.11v-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.42,38.36V36.7h6.18V32.86h2.13V36.7H162v1.66Zm13.18-5.3c-2.21-.51-5-2.19-5.88-4.31-.84,2.17-3.66,3.82-5.87,4.31l-1-1.72c2.63-.38,5.74-2.41,5.74-5.29v-1h2.21v1c0,2.85,3.31,4.94,5.75,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.31,36.71a9.49,9.49,0,0,1-3.55-4.47,8.81,8.81,0,0,1-3.85,4.82l-1.29-1.56a8.43,8.43,0,0,0,4-7.44V25.6h2.19V28a8,8,0,0,0,3.73,7.17Zm2.44,3.66V24.24h2.12V40.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.51,40.17V34.73h4.32V33.36h-6.19V31.67h14.57v1.69H188v1.37h4.39v5.45Zm5.4-15.58c3.64,0,5.65,1.3,5.65,3.09s-2,3.13-5.62,3.13-5.65-1.34-5.65-3.13S183.31,24.59,186.91,24.59Zm0,4.58c2.14,0,3.48-.6,3.48-1.47s-1.27-1.48-3.48-1.48-3.43.58-3.43,1.48S184.74,29.17,186.91,29.17Zm3.35,7.17H183.6v2.18h6.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_169",
    "data-name": "\\uADF8\\uB8F9 169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_40",
    "data-name": "\\uD0C0\\uC6D0 40"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.89,
    cy: 15.71,
    r: 3.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171",
    "data-name": "\\uADF8\\uB8F9 171",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_42",
    "data-name": "\\uD0C0\\uC6D0 42"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.53,
    cy: 29.77,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173",
    "data-name": "\\uADF8\\uB8F9 173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44",
    "data-name": "\\uD0C0\\uC6D0 44"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 2.06,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.5,
    cy: 2.06,
    r: 0.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173-2",
    "data-name": "\\uADF8\\uB8F9 173-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44-2",
    "data-name": "\\uD0C0\\uC6D0 44-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 2.06,
    cy: 14.21,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173-3",
    "data-name": "\\uADF8\\uB8F9 173-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44-3",
    "data-name": "\\uD0C0\\uC6D0 44-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.95,
    cy: 33.67,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173-4",
    "data-name": "\\uADF8\\uB8F9 173-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44-4",
    "data-name": "\\uD0C0\\uC6D0 44-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.16,
    cy: 40.94,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173-5",
    "data-name": "\\uADF8\\uB8F9 173-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44-5",
    "data-name": "\\uD0C0\\uC6D0 44-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.58,
    cy: 28.77,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173-6",
    "data-name": "\\uADF8\\uB8F9 173-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44-6",
    "data-name": "\\uD0C0\\uC6D0 44-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.76,
    cy: 9.32,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.09,
    y: 2.63,
    width: 0.69,
    height: 13.96,
    transform: "translate(-2.14 10.34) rotate(-27.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.58,29.73l-11.06-9.1,13.41-5Zm-9.7-8.87,9.21,7.57L23,16.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_41",
    "data-name": "\\uD0C0\\uC6D0 41"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.53,
    cy: 29.77,
    r: 2.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171-2",
    "data-name": "\\uADF8\\uB8F9 171-2",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_42-2",
    "data-name": "\\uD0C0\\uC6D0 42-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.59,
    cy: 20.65,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_170",
    "data-name": "\\uADF8\\uB8F9 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_41-2",
    "data-name": "\\uD0C0\\uC6D0 41-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.59,
    cy: 20.65,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173-7",
    "data-name": "\\uADF8\\uB8F9 173-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_44-7",
    "data-name": "\\uD0C0\\uC6D0 44-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.76,
    cy: 9.32,
    r: 2.06
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.16,40.94,4.9,33.67,2.06,14.22,17.5,2,35.76,9.31,38.6,28.76Zm-17.31-8L23,39.76,37.48,28.32,34.83,10.05,17.67,3.22,3.17,14.66Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 5.37,
    y1: 33.3,
    x2: 21.33,
    y2: 29.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.09,
    y: 30.85,
    width: 16.51,
    height: 0.69,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -7.51, 4.43)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.53,
    y1: 29.77,
    x2: 23.08,
    y2: 40.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.96,
    y: 29.71,
    width: 0.69,
    height: 10.69,
    transform: "translate(-4.82 3.58) rotate(-8.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.98,
    y: 12.09,
    width: 0.69,
    height: 10.69,
    transform: "matrix(0.6, -0.8, 0.8, 0.6, -11.4, 11.97)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoWhite);
export default __webpack_public_path__ + "static/media/header_logo_white.dfff29c2e5fd158f7fb937486b595899.svg";
export { ForwardRef as ReactComponent };